import axios from 'axios'

import Toggle from '../../../components/atoms/toggle/toggle'

const links = document.querySelectorAll('.js-contact-overlay-toggle')
const content = document.querySelector('.js-contact-overlay-content')

/**
 * Handle show event
 * @param {HTMLElement} link Clicked link element
 */
function onShow (link) {
  const formURL = link.href

  if (!formURL) {
    return
  }

  axios
    .get(formURL)
    .then(response => {
      content.innerHTML = response.data
    })
    .catch(() => {
      content.innerHTML = `
        <section class="notification notification--error">
          <h3 class="notification__title">Fehler</h3>
          <p class="notification__description">Das Kontaktformular konnte leider nicht geladen werden. Bitte versuchen Sie es später erneut.</p>
        </section>
      `
    })
}

/**
 * Handle hide event
 */
function onHide () {
  while (content.firstChild) {
    content.removeChild(content.firstChild)
  }
}

links.forEach(link => new Toggle(link, { onShow, onHide }).init())
